<template>
    <div v-if="isCreateClient" class="pending">
        <h4 class="pending__title">
            {{ $t('pages.assistant.pendingClient.title') }}
        </h4>
        <!-- From `pending.payload`, never from the wording of `reply`: `state`
             and `pending` are the only machine-readable signs of this. -->
        <p class="pending__person">
            <span class="pending__name" dir="auto">{{ fullName }}</span>
            <span class="pending__phone" dir="ltr">{{ payload.phone }}</span>
        </p>
        <p class="pending__note">
            {{ $t('pages.assistant.pendingClient.note') }}
        </p>
        <v-btn
            dark
            color="#967adc"
            class="pending__confirm"
            :disabled="isSending"
            @click="confirm"
        >
            {{ $t('pages.assistant.pendingClient.confirm') }}
        </v-btn>
        <!-- The consent travels as a field on the request and only this button
             attaches it, so a typed "yes" can never work. -->
        <p class="pending__only-button">
            {{ $t('pages.assistant.pendingClient.onlyButton') }}
        </p>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
    assistantActionTypes,
    assistantGetterTypes,
} from '@/store/modules/assistant/types'
import { ASSISTANT_CONFIRM_TYPES } from '@/consts/assistant'

export default {
    name: 'AssistantPendingConfirm',
    computed: {
        ...mapGetters('assistant', {
            pending: assistantGetterTypes.GET_PENDING,
            isSending: assistantGetterTypes.GET_IS_SENDING,
        }),
        isCreateClient: function () {
            return (
                this.pending?.type === ASSISTANT_CONFIRM_TYPES.CREATE_CLIENT &&
                !!this.pending?.payload
            )
        },
        payload: function () {
            return this.pending?.payload || {}
        },
        fullName: function () {
            return [this.payload.name, this.payload.surname]
                .filter((part) => part)
                .join(' ')
        },
    },
    methods: {
        ...mapActions('assistant', {
            confirmCreateClient: assistantActionTypes.CONFIRM_CREATE_CLIENT,
        }),
        confirm: function () {
            this.confirmCreateClient({
                text: this.$t('pages.assistant.pendingClient.sentText'),
            })
        },
    },
}
</script>

<style scoped lang="scss">
.pending {
    padding: 12px 16px;
    background: #f7f7f9;
    border-top: 1px solid #eceeef;

    &__title {
        font-size: 14px;
        font-weight: 600;
        margin: 0 0 6px;
    }

    &__person {
        display: flex;
        flex-direction: column;
        margin: 0 0 6px;
    }

    &__name {
        font-size: 14px;
    }

    &__phone {
        font-size: 12px;
        color: #8a8f94;

        @include for-hebrew {
            text-align: right;
        }
    }

    &__note {
        margin: 0 0 8px;
        font-size: 12px;
        color: #8a8f94;
    }

    &__confirm {
        text-transform: none;
    }

    &__only-button {
        margin: 6px 0 0;
        font-size: 11px;
        color: #8a8f94;
    }
}
</style>
